<script>
import FavoriteTool from '../lib/favorite-tool.vue'
import CategoryFacet from '../lib/category-facet.vue'
import ForMeTool from '../lib/for-me-tool.vue'
import CollapsibleSearch from '../lib/collapsible-search.vue'

export default {
    components: {FavoriteTool, CategoryFacet, ForMeTool, CollapsibleSearch},
    props: {
        favKey: {type: String, required: true},
        favMode: {type: Boolean, required: true},
        filter: {type: Object, required: true},
        eventShortName: {type: String, default: ''},
    },

    computed: {
        favActive() {
            return Object.prototype.hasOwnProperty.call(this.filter, "favorites")
        },
        forMeActive() { return !!this.filter.for_me },
    },

    data() {
        return {
            search: this.filter.search,
            togglerCollapsed: true,
        }
    },

    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        }
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg justify-content-between bg-light px-3">

  <div class="d-flex align-items-center flex-wrap gap-1">
    <favorite-tool v-if="!favMode" :active="favActive" @click="$emit('toggle-favorites', !favActive)" />
    <for-me-tool :active="forMeActive" @click="$emit('toggle-for-me')" />
    <ul class="navbar-nav">
      <category-facet :event-short-name="eventShortName" :value="filter.categories || []"
       @change="$emit('categories', $event)" />
    </ul>
  </div>

  <collapsible-search class="ms-auto" :value="filter.search || ''"
    @search="$emit('search', $event)" @delete-search="$emit('delete-search')" />
</nav>
</template>